import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const resumeStatsApi = createApi({
  reducerPath: 'resumeStatsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/stats'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['ResumeStats'],
  endpoints: (builder) => ({
    resumeStats: builder.mutation({
      query: (obj) => ({
        url: `resume`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['ResumeStats'],
    }),
  }),
});

export const { useResumeStatsMutation } = resumeStatsApi;
